import { render } from "./UnauthorizedView.vue?vue&type=template&id=090b5b18"
import script from "./UnauthorizedView.vue?vue&type=script&lang=js"
export * from "./UnauthorizedView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__